import Core from '../plugin-core-system/core.class.js';
import Cookies from 'js-cookie';

export default class CsAccessibilityAnimation extends Core {

  static options = {
    playAnimationsByDefault: true,
    cookieName: 'cs-animations',
    playIconClass: 'cs-icon-play-circle',
    pauseIconClass: 'cs-icon-pause-circle'
  };

  handleAnimations(startAnimation) {
    const body = document.querySelector('body');
    const splideSliders = document.getElementsByClassName('splide splide--banner');
    const triggerButton = this.el;
    const triggerButtonText = triggerButton.closest('.accessibility__item')?.querySelector('.js-toggle-animations-text');
    const videoList = document.querySelectorAll('video[autoplay]');

    if (startAnimation) {
      if (videoList.length) {
        videoList.forEach(video => {
          const playPromise = video.play();

          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        });
      }

      // If there is a Progress Slider, a custom event is triggered
      if (splideSliders.length > 0) {
        const event = new CustomEvent('splideSlidersFound', {
          detail: {
            found: true
          }
        });
        document.dispatchEvent(event);
      }

      const stopAnimationsText = triggerButton.dataset.titleStopAnimations;

      // start css animation
      body.classList.remove('h-stop-animations');

      // swap icon for trigger
      triggerButton.classList.remove('cs-icon-play-circle');
      triggerButton.classList.add('cs-icon-pause-circle');

      // set title and aria-label
      triggerButton.setAttribute('title', triggerButton.dataset.titleStopAnimations);
      triggerButton.setAttribute('aria-label', triggerButton.dataset.titleStopAnimations);

      if (triggerButtonText) {
        triggerButtonText.textContent = stopAnimationsText;
      }

      // set Cookie
      Cookies.set(CsAccessibilityAnimation.options.cookieName, '1');
    } else {

      if (videoList.length) {
        videoList.forEach((video) => {
          video.pause();
        });
      }

      // If there is a Progress Slider, a custom event is triggered
      if (splideSliders.length > 0) {
        const event = new CustomEvent('splideSlidersFound', {
          detail: {
            found: false
          }
        });
        document.dispatchEvent(event);
      }

      const startAnimationsText = triggerButton.dataset.titleStartAnimations;

      // stop css animation immediately
      body.classList.add('h-stop-animations');

      // swap icon for trigger
      triggerButton.classList.add('cs-icon-play-circle');
      triggerButton.classList.remove('cs-icon-pause-circle');

      // set title and aria-label
      triggerButton.setAttribute('title', triggerButton.dataset.titleStartAnimations);
      triggerButton.setAttribute('aria-label', triggerButton.dataset.titleStartAnimations);

      if (triggerButtonText) {
        triggerButtonText.textContent = startAnimationsText;
      }

      // set Cookie
      Cookies.set(CsAccessibilityAnimation.options.cookieName, '0');
    }
  }

  initAnimations() {
    if (!Cookies.get(CsAccessibilityAnimation.options.cookieName)) {

      // Cookie is not set yet
      this.handleAnimations(CsAccessibilityAnimation.options.playAnimationsByDefault);
    } else {

      // Cookie is set
      this.handleAnimations(Cookies.get(CsAccessibilityAnimation.options.cookieName) === '1');
    }
  }

  initToggleButton() {
    this.el.addEventListener('click', () => {
      this.handleAnimations(Cookies.get(CsAccessibilityAnimation.options.cookieName) !== '1');
    });
  }

  init() {
    this.initAnimations();
    this.initToggleButton();
  }
}
